<template>
	<div class="flex flex-col justify-center items-center px-4 sm:px-6">
        <div class="flex justify-center items-center spinner-bg rounded-full w-20 h-20 mb-5">
            <SvgSuccessCheck />
        </div>

        <h1 class="text-1xl font-medium _text-cream-500 mb-3">
           	Your Form has been submitted!
        </h1>
        <p class="text-base font-medium text-gray-400 text-center">
            Thank you for completing the guarantor form and uploading the required documents.
            Your submission has been received and is now under review.
        </p>
    </div>
</template>

<script>
import SvgSuccessCheck from "@/svg/SuccessCheck"

export default {
	components: { SvgSuccessCheck }
}
</script>
